<template>
    <div class="plan-badge" :class="[type, `plan-badge__${align}`]">
        <div v-if="type === 'bestDeal'" class="plan-badge__bestDeal">
            <Icon icon="pricing-best-dial" alt=""/>
        </div>
        <div v-if="type === 'currentPlan'" class="plan-badge__currentPlan" :class="`plan-badge__currentPlan__${align}`">
            <p class="plan-badge__text">
                Your Current Plan
            </p>
        </div>
    </div>
</template>

<script>
import Icon from '@/components/Theme/Icon'
export default {
    name: 'PlanBadge',
    components: {
        Icon,
    },
    props: {
        type: {
            type: String,
            default: 'currentPlan'
        },
        index: {
            type: Number,
            default: 0
        }
    },
    computed: {
        align(){
            switch(this.index){
                case 1:
                    return 'center';
                case 2:
                    return 'right';
                default: 
                    return 'left'
            }
        }
    }
}
</script>

<style lang="scss" scoped>
$badge_left_radius: 8px 0 0 8px;
$badge_right_radius: 0 8px 8px 0;
$badge_center_radius: 8px;
.plan-badge {
    width: 100%;
    position: absolute;
    &.bestDeal {
        left: 0;
        top: 0;
    }
    &.currentPlan {
        padding: 6px 0;
        background: #F4F7FA;
        top: 8px;
        
        &.plan-badge__left {
            border-radius: $badge_left_radius;
            left: 8px;
        }
        &.plan-badge__right {
            border-radius: $badge_right_radius;
            right: 8px;
        }
        &.plan-badge__center {
            border-radius: $badge_center_radius;
            left: 8px;
            right: 8px;
            width: auto;
        }

        @media (max-width: 992px) {
            left: 8px;
            right: 8px;
            border-radius: $badge_center_radius!important;
            width: auto;;
        }
    }
    &__text {
        font-size: 14px;
        line-height: 20px;
        font-family: 'Eina SemiBold';
        text-align: center;
        margin-bottom: 0;
    }
    &__bestDeal {
        left: 0;
        top: 0;
    }
}
</style>